import { getMutex } from "../utils/simpleMutex"
import { listEntitiesAsync } from "../api"

// Shared cache of drop-down options, keyed by "apiEntity + filter" - one fetch per list per page.
const EntityState = {
  _entities: new Map(),
  _mutex: getMutex(),
  _fatalError: false,
  clearAll() {
    this._entities.clear()
  },
  async getEntitiesAsync(fetchAuthAsync, apiEntity, filter = "") {
    const [lock, release] = this._mutex.getLock()
    await lock
    if (!this._entities.has(`${apiEntity}${filter}`) && !this._fatalError) {
      const result = await listEntitiesAsync(fetchAuthAsync, apiEntity, filter)
      if (!Array.isArray(result)) {
        this._fatalError = true
      } else {
        this._entities.set(`${apiEntity}${filter}`, result)
      }
    }
    release()
    return this._entities.get(`${apiEntity}${filter}`) || []
  },
}

export { EntityState }
